(function () {
  'use strict';

  angular
    .module('app.autocomplete', [])

    .directive('autoCompleteSearch', function () {
      return {
        restrict: 'E',
        scope: true,
        controllerAs: 'searchCtrl',
        /* @ngInject */
        controller: ["$rootScope", "$element", "$location", "$timeout", "RoutesService", "searchFinderService", function ($rootScope, $element, $location, $timeout, RoutesService, searchFinderService) {
          var ctrl = this;

          ctrl.inputBlur = function () {
            ctrl.focus = false;
            $rootScope.$broadcast('searchBlur');
          };

          ctrl.submitForm = function (event) {
            event.preventDefault();
          };

          ctrl.inputChangeHandler = function () {
            $rootScope.$broadcast('searchUpdate');
          };

          ctrl.goSearch = function (event, fromBtn) {
            if (fromBtn) {
              event.stopPropagation();
            } else {
              if (event.which === 13) {
                $(event.target).blur();
              } else {
                return;
              }
            }
            $timeout(goSearch, 600);
          };

          ctrl.$onInit = function () {
            searchFinderService.setCtrl(ctrl);
          };

          function goSearch() {
            if (!ctrl.searchStr || ctrl.searchStr === '') return;
            var url = RoutesService.getUrlByName('Search') + '/' + encodeURIComponent(ctrl.searchStr.split(' ').join('+')).replace(new RegExp('%2F', 'g'), '%252F');
            $location.path(url);
            $rootScope.$broadcast('searchClose');
          }

        }]
      };
    });

})();
